import { RouteObject } from '@rocketlane/rocket-router';
import { PageLoading } from 'components/atoms/loading';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { useGetExpenseAccess } from 'queries/expense-management/expense';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { NotFoundPage, ExpensesRoutes } from 'routes/vendor/lazy-imports';

const ExpenseRoutesLayout = ({ children }: { children: React.ReactNode }) => {
  const [isExpensesFeatureEnabled] = useAccountFeature(AccountFeature.Expenses);
  const { data: expenseAccess, isInitialLoading } = useGetExpenseAccess(
    undefined,
    undefined,
    {
      enabled: isExpensesFeatureEnabled,
    },
  );

  if (isInitialLoading) {
    return <PageLoading />;
  }

  // Feature should be enabled and user should have access to view expenses or approvals
  if (
    (expenseAccess?.canViewForMyself || expenseAccess?.canViewApprovals) &&
    isExpensesFeatureEnabled
  ) {
    return <>{children}</>;
  }

  return <NotFoundPage />;
};

export const expenseRoutes: RouteObject = {
  path: `${ROUTE_PATHS.EXPENSES}/${ROUTE_PATHS.MATCH_ALL}`,
  element: (
    <SecureRoute>
      <ExpenseRoutesLayout>
        <ExpensesRoutes />
      </ExpenseRoutesLayout>
    </SecureRoute>
  ),
};
